import React from 'react'

const RestroMenuShimmer = () => {
  return (
    <div className='w-8/12 mx-auto h-screen flex flex-col gap-3'>
        <div className='bg-gray-800 h-[148px] w-full border rounded-md'></div>
        <div className='bg-gray-800 h-[48px] w-full border rounded-md'></div>
        <div className='bg-gray-800 h-[48px] w-full border rounded-md'></div>
        <div className='bg-gray-800 h-[48px] w-full border rounded-md'></div>
        <div className='bg-gray-800 h-[48px] w-full border rounded-md'></div>
        <div className='bg-gray-800 h-[48px] w-full border rounded-md'></div>
        <div className='bg-gray-800 h-[48px] w-full border rounded-md'></div>
        <div className='bg-gray-800 h-[48px] w-full border rounded-md'></div>
    </div>
  )
}

export default RestroMenuShimmer